document.addEventListener('DOMContentLoaded', () => {
  const { body } = document;
  const mobileNavbar = document.querySelector('.mobile-navbar');
  let el;

  if (body.classList.contains('show-cookie-notice')) {
    el = document.querySelector('.cookie-notice');
  } else if (mobileNavbar) {
    el = mobileNavbar;
  }

  const setMarginBottom = () => body.style.marginBottom = ((el && el.offsetHeight) || 0) + 'px';
  setMarginBottom();

  if (el) {
    window.addEventListener('resize', setMarginBottom);
  }
});
